module.exports = __webpack_public_path__ + "img/album04_09.7385faf8.jpg";